import { render, staticRenderFns } from "./onereport.vue?vue&type=template&id=01a4b312&scoped=true"
import script from "./onereport.vue?vue&type=script&lang=js"
export * from "./onereport.vue?vue&type=script&lang=js"
import style0 from "./onereport.vue?vue&type=style&index=0&id=01a4b312&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a4b312",
  null
  
)

export default component.exports